<template>
  <div id="splash-confirmation-screen">
    <v-icon name="check" scale="4" style="color: #a0a0a0; opacity: 0.5" />
    <p style="margin-top: 15px; color: #a0a0a0; font-size: 2em">Import des résultats réussi</p>
    <a :href="'https://sportips.fr/plateformeResultats/#/epreuve?id=' + id"><b-button>Aller aux résultats</b-button></a
    ><br />
    <a :href="$store.getters.base_url + '/admin/QRCode/get.php?id=' + id" target="_blank"><b-button>Génerer un lien QRCode</b-button></a>
  </div>
</template>

<script>
export default {
  props: ["id"],
  components: {},

  data() {
    return {};
  },
};
</script>

<style scoped>
#splash-confirmation-screen {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 1000000;
  background-color: #e7e7e7 !important;
  opacity: 1;
}
</style>
